angular.module("events")

    .controller("EventsAnnexesCtrl", ['LoginService', '$timeout', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'Upload', 'logService',
        function (LoginService, $timeout, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, Upload, logService) {

            $scope.annexes_types = {};
            $scope.files = [];
            $scope.event.changesNotSaved = false;
            $scope.event_id = $stateParams.id;
            $scope.annexes_events = [];
            $scope.template_options = [{ value: "template_one_column", name: $filter('translate')('events.programs_acts.one_column') }, { value: "template_type_photo", name: $filter('translate')('events.programs_acts.type_photo') }];

            //Opciones del editor
            $scope.tinymceOptions = {
                resize: true,
                contextmenu: false,
                branding: false,
                //forced_root_block: 'div',
                //min_height: 60,
                //height: 60,
                schema: "html5",
                formats: {
                    bold: { inline: 'b' },
                    underline: { inline: 'u' },
                    italic: { inline: 'i' },
                    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "left" } },
                    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "center" } },
                    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "right" } },
                    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div', attributes: { align: "justify" } },
                },
                invalid_elements: 'strong,em',
                invalid_styles: { 
                    'table': 'height', 
                    'tr' : 'height',
                    'th' : 'height',
                    'td' : 'height'
                },
                fontsize_formats: "8px 10px 12px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
                font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
                body_class: 'custom_tinymce_content',
                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                paste_as_text: true,
                plugins: 'paste textcolor code image lists advlist table link autoresize noneditable',
                toolbar: "undo redo | fontselect fontsizeselect forecolor | bold underline italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent link | image-custom | table | code",
                menubar: false,

                setup: function (editor) {
                    editor.ui.registry.addButton('image-custom', {
                        title: $filter('translate')('events.image') ,
                        icon: 'image',
                        onAction: function () {
                            modalService.image({
                                title: $filter('translate')('events.image'),
                                event_id: $scope.event_id,
                                onAccept: function (resultModal) {
                                    logService.debug(resultModal);
                                    var html = "<img src='/api" + resultModal.path + "' />";
                                    editor.insertContent(html);
                                },
                                onCancel: function (response) {
                                    //nada
                                }
                            });
                        }
                    });
                }
            };

            Restangular.all('AnnexesTypes').getList({}).then(function (response) {
                $scope.annexes_types = response;
                $scope.cargaInicial = true;
            });

            $scope.loadData = function () {
                Restangular.all('EventsAnnexes').getList({ event_id: $scope.event_id, is_explicit_annex: false }).then(function (response) {
                    $scope.annexes_events = response;
                    angular.forEach($scope.annexes_events, function (row) {
                        if (row.template_images == null) {
                            row.template_images = "template_one_column";
                        }
                    })
                });
            };

            $scope.loadData();

            $scope.add_annex = function (annex_type_id) {
                var annexes_tl = [];
                $scope.event.changesNotSaved = true;
                Restangular.one('AnnexesTypes', annex_type_id).get().then(function (results) {
                    angular.forEach(results.FK_events_programs_annexes_types_tl_events_programs_annexes_types, function (rows_tl) {
                        annexes_tl.push({
                            language_id: rows_tl.language_id,
                            title: rows_tl.name
                        });
                    });
                    $scope.annexes_events.push({
                        id: 0,
                        event_id: $scope.event_id,
                        is_explicit_annex: false,
                        annex_type_id: annex_type_id,
                        FK_events_programs_annexes_events_programs_annexes_types: results,
                        FK_events_programs_annexes_tl_events_programs_annexes: annexes_tl
                    });

                    $scope.save();
                });
            }

            $scope.addImages = function (files, annex_event, errFiles) {
                $scope.event.changesNotSaved = true;
                if (errFiles.length > 0) {
                    logService.debug("Ha ocurrido un error con las imágenes: ")
                    logService.debug(errFiles);
                }
                angular.forEach(files, function (file, idx) {
                    Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "events_programs_annexes" }).then(function (result) {
                        if (result.filter(e => e.type === file.type).length <= 0) {
                            var typeAllowed = result.map(o => o.type).join(', ');
                            $scope.event.changesNotSaved = false;
                            modalService.message({
                                title: "Error",
                                message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                                onAccept: function () { }
                            });
                        } else {
                            var fileReader = new FileReader();
                            var maxSizeAllowed = result.find(e => e.type === file.type).maxsize;
                            fileReader.onload = function (event) {
                                if (!event.target) return;
                                var image = new Image();
                                image.src = event.target.result as string;

                                image.onload = function () {
                                    var sizeFileMB = file.size / 1024;
                                    if (sizeFileMB > 0) {
                                        //Comprobamos que no pase del tamaño limite de imagen
                                        if (sizeFileMB > maxSizeAllowed) {
                                            $scope.event.changesNotSaved = false;
                                            modalService.message({
                                                title: "Error",
                                                message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                                onAccept: function () { }
                                            });
                                        } else {
                                            file.is_deleted = false;
                                            file.orden = idx;
                                            file.is_deleted = false;
                                            file.is_inserted = false;
                                            file.image = image.src;
                                            file.entity_type = "events_programs_annexes";
                                            file.entity_type_id = annex_event.id;
                                            $scope.annexes_events.find(element => element.id == annex_event.id).files.push(file);
                                            if (!$scope.$$phase) $scope.$apply()

                                        }
                                    } else {
                                        file.is_deleted = false;
                                        file.is_inserted = false;
                                        file.orden = idx;
                                        file.image = image.src;
                                        $scope.annexes_events.find(element => element.id == annex_event.id).files.push(file);
                                        if (!$scope.$$phase) $scope.$apply()
                                    }
                                };
                            };
                            fileReader.readAsDataURL(file);
                        }
                    });
                });
            };

            $scope.removeFile = function (file) {
                $scope.event.changesNotSaved = true;
                modalService.confirm({
                    title: "Borrar documento",
                    message: "¿Está usted seguro de querer borrar " + (angular.isUndefined(file.name) ? file.filename : file.name) + "?",
                    onAccept: function () {
                        angular.forEach($scope.annexes_events, function (annex) {
                            angular.forEach(annex.files, function (item) {
                                if (file.image == item.image) {
                                    item.is_deleted = true;
                                }
                            })
                        });
                    }
                });
            }

            $scope.save = function () {
                angular.forEach($scope.annexes_events, function (annex) {
                    if (annex.id != 0) {
                        annex.put().then(function (result) {
                            if (angular.isDefined(result.id)) {
                                annex = result;
                                $scope.loadData();
                            } else {
                                $scope.errorMessage = result.message;
                            }
                            $scope.event.changesNotSaved = false;
                        });

                    } else {
                        Restangular.all('EventsAnnexes').post(annex).then(function (result) {
                            if (angular.isDefined(result.id)) {
                                annex.id = result.id;
                                $scope.loadData();
                            } else {
                                $scope.errorMessage = result.message;
                            }
                        });
                    }
                });

                $scope.saveImages();

            }

            $scope.saveImages = function () {
                angular.forEach($scope.annexes_events, function (annex) {
                    angular.forEach(annex.files, function (file) {
                        if (file.is_deleted) {
                            if ((!angular.isUndefined(file.id) || file.id != null)) {
                                Restangular.one('Files', file.id).remove().then(function () {
                                    toastr.success($filter('translate')('general.deleted_success'));
                                });
                            }
                        } else {
                            if ((angular.isUndefined(file.id) || file.id == null) && !file.is_inserted) {
                                file.upload = Upload.upload({
                                    url: (window as any).CONFIG.api_url + "Files/uploadFile",
                                    data: { file: file, name: file.name, folder_id: null, entity_type: file.entity_type, entity_type_id: file.entity_type_id, is_public: false },
                                }).then(function (result) {
                                    if (result.data.FileId != null) {
                                        file.id = result.data.FileId;
                                    }
                                });
                            }
                        }
                    });
                });
            }

            $scope.delete = function (event_annex_id) {
                modalService.confirm({
                    title: $filter('translate')('general.delete_button'),
                    message: $filter('translate')('general.delete_message') + "?",
                    onAccept: function () {
                        Restangular.one('EventsAnnexes', event_annex_id).remove().then(function () {
                            toastr.success($filter('translate')('general.delete_success'));
                            $scope.loadData();
                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });
            }


        }])
;

